import classNames from 'classnames';
import React from 'react';

interface IRadioCheckboxProps extends React.HTMLAttributes<HTMLInputElement> {
  size?: 'sm' | 'md' | 'lg';
}

const sizeClassMapping = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
};
const RadioCheckbox: React.FC<React.PropsWithChildren<IRadioCheckboxProps>> = ({
  className,
  size = 'md',
  ...props
}) => {
  return (
    <label className={classNames(className, 'inline-flex')}>
      <input {...props} type="checkbox" className="hidden peer" />
      <span
        className={classNames(
          sizeClassMapping[size],
          'bg-white border border-gray-400 p-1 rounded-full overflow-hidden inline-flex items-stretch peer-checked:hidden'
        )}
      >
        <span className="flex-grow invisible rounded-full" />
      </span>

      <span
        className={classNames(
          sizeClassMapping[size],
          'bg-white border border-primary p-1 rounded-full overflow-hidden hidden items-stretch peer-checked:inline-flex'
        )}
      >
        <span className="flex-grow rounded-full bg-primary" />
      </span>
    </label>
  );
};
export default RadioCheckbox;
